module.exports = __webpack_public_path__ + "static/media/flow-expand.0acc90a0.svg";